<template>
    <div class="new-address-modal">
        <div class="modal-body">
            <div class="modal-inner">
                <div class="header-line">
                    <h3>New shipping address</h3>

                    <button v-on:click="hideAddAddressModal">
                        <i class="fa fa-close fa-lg mt-3"></i>
                    </button>
                </div>

                <b-form-group :class="['company-field', errors && errors.has('company-name') ? 'error-field' : '']">
                    <label for="aname">Address name</label>
                    <input type="text" class="form-control" name="aname" v-model="newAddress.addressName" v-validate="'required'" data-vv-as="Address name">
                    <span v-show="errors && errors.has('aname')" class="validate-warning">{{ errors.first('aname') }}</span>
                </b-form-group>

                <div class="auto-fill-address">
                    <input type="text" placeholder="Start typing address to display hints" v-model="location" @input="unlockHints()" autocomplete="false" class="form-control auto-fill-input">
                    <div v-if="searchResults.length > 0 && hintSelected == false" class="auto-fill-hints-list">
                        <div v-for="(result, i) in searchResults" :key="i" class="auto-fill-hint" @click="getSelectedLocation(result)">
                            {{ result.description }}
                        </div>
                    </div>
                    <div class="w-30 address-card">
                        <fieldset :class="[errors && errors.has('addr1') ? 'error-field' : '']">
                            <label for="addr1">Address line 1</label>
                            <input name="addr1" id="addr1" :disabled="searchResults.length == 0 || hintSelected == false" data-vv-as="address line 1" v-model="newAddress.addressLine1" v-validate="'required'" class="form-control"/>
                            <span v-show="errors && errors.has('addr1')" class="validate-warning">{{ errors.first('addr1') }}</span>
                        </fieldset>
                        <fieldset>
                            <label>Address line 2</label>
                            <input name="addr2" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.addressLine2" class="form-control"/>
                        </fieldset>
                        <fieldset :class="[errors && errors.has('city') ? 'error-field' : '']">
                            <label for="city">City</label>
                            <input name="city" id="city" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.city" v-validate="'required'" class="form-control"/>
                            <span v-show="errors && errors.has('city')" class="validate-warning">{{ errors.first('city') }}</span>
                        </fieldset>
                        <fieldset v-if="newAddress.country == 'United States'">
                            <label>State / Region</label>
                            <select name="state" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.state" class="form-control">
                                <option v-for="state in stateList" :key="state.abbreviation" :value="state.abbreviation">{{state.name}}</option>
                            </select>
                        </fieldset>
                        <fieldset v-else>
                            <label>State / Region</label>
                            <input name="state" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.state" class="form-control"/>
                        </fieldset>
                        <fieldset v-if="newAddress.country == 'United States'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label>Zip</label>
                            <input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.postalCode" v-validate="{required: true, regex: /^[0-9]{5}(-[0-9]{4})?$/}" data-vv-as="postal code" class="form-control"/>
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </fieldset>
                        <fieldset v-if="newAddress.country == 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label>Zip</label>
                            <input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.postalCode" v-validate="{required: true, regex: /^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}$/}" data-vv-as="postal code" class="form-control"/>
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </fieldset>
                        <fieldset v-if="newAddress.country != 'United States' && newAddress.country != 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label>Zip</label>
                            <input name="pcode-user" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.postalCode" v-validate="{required: true}" data-vv-as="postal code" class="form-control"/>
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </fieldset>
                        <fieldset>
                            <label>Country</label>
                            <select name="country" :disabled="searchResults.length == 0 || hintSelected == false" v-model="newAddress.country" class="form-control">
                                <option v-for="country in countriesList" :value="country.name" :key="country.code">{{country.name}}</option>
                            </select>
                        </fieldset>
                    </div>
                </div>
                <b-form-group :class="[phoneNumberValidation ? 'error-field' : '']">
                    <label for="pnumber-user">Phone Number</label>
                    <vue-tel-input class="form-control" v-bind="bindProps" @input="parseNewPhoneNumber" :validCharactersOnly="true" v-model="phoneNumber" name="errorPhoneNumber"></vue-tel-input>
                    <span v-if="phoneNumberValidation" class="validate-warning">Please type phone number in right format</span>
                </b-form-group>
            </div>
            <div class="control-bar text-right">
                <button class="btn btn-light" v-on:click="hideAddAddressModal">Cancel</button>
                <button class="btn btn-primary" :disabled="location == '' || newAddress.addressName == '' || newAddress.addressLine1 == '' || newAddress.city == '' || newAddress.country == '' || newAddress.postalCode == ''" @click="saveNewContact">Add</button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStorage from '../../variables'
import { VueTelInput } from 'vue-tel-input'
import VeeValidate from "vee-validate";
import awesomePhonenumber from 'awesome-phonenumber'
import globalStore from "../../variables";
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})

const veeValidateConfig = {};

Vue.use(VeeValidate, veeValidateConfig);

    export default {
        name: "NewAddres",
        components: {
            VueTelInput,
            awesomePhonenumber
        },
        data() {
            return {
                newAddress: {
                    addressName: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    postalCode: '',
                    country: '',
                    state: '',
                    contactNumber: {
                        dialCode: null,
                        number: null
                    }
                },
                phoneNumberValidation: false,
                phoneNumber: '',
                stateList: [
                    {
                        "name": "Alabama",
                        "abbreviation": "AL"
                    },
                    {
                        "name": "Alaska",
                        "abbreviation": "AK"
                    },
                    {
                        "name": "American Samoa",
                        "abbreviation": "AS"
                    },
                    {
                        "name": "Arizona",
                        "abbreviation": "AZ"
                    },
                    {
                        "name": "Arkansas",
                        "abbreviation": "AR"
                    },
                    {
                        "name": "California",
                        "abbreviation": "CA"
                    },
                    {
                        "name": "Colorado",
                        "abbreviation": "CO"
                    },
                    {
                        "name": "Connecticut",
                        "abbreviation": "CT"
                    },
                    {
                        "name": "Delaware",
                        "abbreviation": "DE"
                    },
                    {
                        "name": "District Of Columbia",
                        "abbreviation": "DC"
                    },
                    {
                        "name": "Federated States Of Micronesia",
                        "abbreviation": "FM"
                    },
                    {
                        "name": "Florida",
                        "abbreviation": "FL"
                    },
                    {
                        "name": "Georgia",
                        "abbreviation": "GA"
                    },
                    {
                        "name": "Guam",
                        "abbreviation": "GU"
                    },
                    {
                        "name": "Hawaii",
                        "abbreviation": "HI"
                    },
                    {
                        "name": "Idaho",
                        "abbreviation": "ID"
                    },
                    {
                        "name": "Illinois",
                        "abbreviation": "IL"
                    },
                    {
                        "name": "Indiana",
                        "abbreviation": "IN"
                    },
                    {
                        "name": "Iowa",
                        "abbreviation": "IA"
                    },
                    {
                        "name": "Kansas",
                        "abbreviation": "KS"
                    },
                    {
                        "name": "Kentucky",
                        "abbreviation": "KY"
                    },
                    {
                        "name": "Louisiana",
                        "abbreviation": "LA"
                    },
                    {
                        "name": "Maine",
                        "abbreviation": "ME"
                    },
                    {
                        "name": "Marshall Islands",
                        "abbreviation": "MH"
                    },
                    {
                        "name": "Maryland",
                        "abbreviation": "MD"
                    },
                    {
                        "name": "Massachusetts",
                        "abbreviation": "MA"
                    },
                    {
                        "name": "Michigan",
                        "abbreviation": "MI"
                    },
                    {
                        "name": "Minnesota",
                        "abbreviation": "MN"
                    },
                    {
                        "name": "Mississippi",
                        "abbreviation": "MS"
                    },
                    {
                        "name": "Missouri",
                        "abbreviation": "MO"
                    },
                    {
                        "name": "Montana",
                        "abbreviation": "MT"
                    },
                    {
                        "name": "Nebraska",
                        "abbreviation": "NE"
                    },
                    {
                        "name": "Nevada",
                        "abbreviation": "NV"
                    },
                    {
                        "name": "New Hampshire",
                        "abbreviation": "NH"
                    },
                    {
                        "name": "New Jersey",
                        "abbreviation": "NJ"
                    },
                    {
                        "name": "New Mexico",
                        "abbreviation": "NM"
                    },
                    {
                        "name": "New York",
                        "abbreviation": "NY"
                    },
                    {
                        "name": "North Carolina",
                        "abbreviation": "NC"
                    },
                    {
                        "name": "North Dakota",
                        "abbreviation": "ND"
                    },
                    {
                        "name": "Northern Mariana Islands",
                        "abbreviation": "MP"
                    },
                    {
                        "name": "Ohio",
                        "abbreviation": "OH"
                    },
                    {
                        "name": "Oklahoma",
                        "abbreviation": "OK"
                    },
                    {
                        "name": "Oregon",
                        "abbreviation": "OR"
                    },
                    {
                        "name": "Palau",
                        "abbreviation": "PW"
                    },
                    {
                        "name": "Pennsylvania",
                        "abbreviation": "PA"
                    },
                    {
                        "name": "Puerto Rico",
                        "abbreviation": "PR"
                    },
                    {
                        "name": "Rhode Island",
                        "abbreviation": "RI"
                    },
                    {
                        "name": "South Carolina",
                        "abbreviation": "SC"
                    },
                    {
                        "name": "South Dakota",
                        "abbreviation": "SD"
                    },
                    {
                        "name": "Tennessee",
                        "abbreviation": "TN"
                    },
                    {
                        "name": "Texas",
                        "abbreviation": "TX"
                    },
                    {
                        "name": "Utah",
                        "abbreviation": "UT"
                    },
                    {
                        "name": "Vermont",
                        "abbreviation": "VT"
                    },
                    {
                        "name": "Virgin Islands",
                        "abbreviation": "VI"
                    },
                    {
                        "name": "Virginia",
                        "abbreviation": "VA"
                    },
                    {
                        "name": "Washington",
                        "abbreviation": "WA"
                    },
                    {
                        "name": "West Virginia",
                        "abbreviation": "WV"
                    },
                    {
                        "name": "Wisconsin",
                        "abbreviation": "WI"
                    },
                    {
                        "name": "Wyoming",
                        "abbreviation": "WY"
                    }
                ],
                countriesList: [
                    {"name": "Afghanistan", "code": "AF"},
                    {"name": "Åland Islands", "code": "AX"},
                    {"name": "Albania", "code": "AL"},
                    {"name": "Algeria", "code": "DZ"},
                    {"name": "American Samoa", "code": "AS"},
                    {"name": "AndorrA", "code": "AD"},
                    {"name": "Angola", "code": "AO"},
                    {"name": "Anguilla", "code": "AI"},
                    {"name": "Antarctica", "code": "AQ"},
                    {"name": "Antigua and Barbuda", "code": "AG"},
                    {"name": "Argentina", "code": "AR"},
                    {"name": "Armenia", "code": "AM"},
                    {"name": "Aruba", "code": "AW"},
                    {"name": "Australia", "code": "AU"},
                    {"name": "Austria", "code": "AT"},
                    {"name": "Azerbaijan", "code": "AZ"},
                    {"name": "Bahamas", "code": "BS"},
                    {"name": "Bahrain", "code": "BH"},
                    {"name": "Bangladesh", "code": "BD"},
                    {"name": "Barbados", "code": "BB"},
                    {"name": "Belarus", "code": "BY"},
                    {"name": "Belgium", "code": "BE"},
                    {"name": "Belize", "code": "BZ"},
                    {"name": "Benin", "code": "BJ"},
                    {"name": "Bermuda", "code": "BM"},
                    {"name": "Bhutan", "code": "BT"},
                    {"name": "Bolivia", "code": "BO"},
                    {"name": "Bosnia and Herzegovina", "code": "BA"},
                    {"name": "Botswana", "code": "BW"},
                    {"name": "Bouvet Island", "code": "BV"},
                    {"name": "Brazil", "code": "BR"},
                    {"name": "British Indian Ocean Territory", "code": "IO"},
                    {"name": "Brunei Darussalam", "code": "BN"},
                    {"name": "Bulgaria", "code": "BG"},
                    {"name": "Burkina Faso", "code": "BF"},
                    {"name": "Burundi", "code": "BI"},
                    {"name": "Cambodia", "code": "KH"},
                    {"name": "Cameroon", "code": "CM"},
                    {"name": "Canada", "code": "CA"},
                    {"name": "Cape Verde", "code": "CV"},
                    {"name": "Cayman Islands", "code": "KY"},
                    {"name": "Central African Republic", "code": "CF"},
                    {"name": "Chad", "code": "TD"},
                    {"name": "Chile", "code": "CL"},
                    {"name": "China", "code": "CN"},
                    {"name": "Christmas Island", "code": "CX"},
                    {"name": "Cocos (Keeling) Islands", "code": "CC"},
                    {"name": "Colombia", "code": "CO"},
                    {"name": "Comoros", "code": "KM"},
                    {"name": "Republic of the Congo", "code": "CG"},
                    {"name": "Democratic Republic of the Congo", "code": "CD"},
                    {"name": "Cook Islands", "code": "CK"},
                    {"name": "Costa Rica", "code": "CR"},
                    {"name": "Cote D\"Ivoire", "code": "CI"},
                    {"name": "Croatia", "code": "HR"},
                    {"name": "Cuba", "code": "CU"},
                    {"name": "Cyprus", "code": "CY"},
                    {"name": "Czechia", "code": "CZ"},
                    {"name": "Denmark", "code": "DK"},
                    {"name": "Djibouti", "code": "DJ"},
                    {"name": "Dominica", "code": "DM"},
                    {"name": "Dominican Republic", "code": "DO"},
                    {"name": "Ecuador", "code": "EC"},
                    {"name": "Egypt", "code": "EG"},
                    {"name": "El Salvador", "code": "SV"},
                    {"name": "Equatorial Guinea", "code": "GQ"},
                    {"name": "Eritrea", "code": "ER"},
                    {"name": "Estonia", "code": "EE"},
                    {"name": "Ethiopia", "code": "ET"},
                    {"name": "Islas Malvinas", "code": "FK"},
                    {"name": "Faroe Islands", "code": "FO"},
                    {"name": "Fiji", "code": "FJ"},
                    {"name": "Finland", "code": "FI"},
                    {"name": "France", "code": "FR"},
                    {"name": "French Guiana", "code": "GF"},
                    {"name": "French Polynesia", "code": "PF"},
                    {"name": "French Southern Territories", "code": "TF"},
                    {"name": "Gabon", "code": "GA"},
                    {"name": "Gambia", "code": "GM"},
                    {"name": "Georgia", "code": "GE"},
                    {"name": "Germany", "code": "DE"},
                    {"name": "Ghana", "code": "GH"},
                    {"name": "Gibraltar", "code": "GI"},
                    {"name": "Greece", "code": "GR"},
                    {"name": "Greenland", "code": "GL"},
                    {"name": "Grenada", "code": "GD"},
                    {"name": "Guadeloupe", "code": "GP"},
                    {"name": "Guam", "code": "GU"},
                    {"name": "Guatemala", "code": "GT"},
                    {"name": "Guernsey", "code": "GG"},
                    {"name": "Guinea", "code": "GN"},
                    {"name": "Guinea-Bissau", "code": "GW"},
                    {"name": "Guyana", "code": "GY"},
                    {"name": "Haiti", "code": "HT"},
                    {"name": "Heard Island and McDonald Islands", "code": "HM"},
                    {"name": "Vatican City", "code": "VA"},
                    {"name": "Honduras", "code": "HN"},
                    {"name": "Hong Kong", "code": "HK"},
                    {"name": "Hungary", "code": "HU"},
                    {"name": "Iceland", "code": "IS"},
                    {"name": "India", "code": "IN"},
                    {"name": "Indonesia", "code": "ID"},
                    {"name": "Iran, Islamic Republic Of", "code": "IR"},
                    {"name": "Iraq", "code": "IQ"},
                    {"name": "Ireland", "code": "IE"},
                    {"name": "Isle of Man", "code": "IM"},
                    {"name": "Israel", "code": "IL"},
                    {"name": "Italy", "code": "IT"},
                    {"name": "Jamaica", "code": "JM"},
                    {"name": "Japan", "code": "JP"},
                    {"name": "Jersey", "code": "JE"},
                    {"name": "Jordan", "code": "JO"},
                    {"name": "Kazakhstan", "code": "KZ"},
                    {"name": "Kenya", "code": "KE"},
                    {"name": "Kiribati", "code": "KI"},
                    {"name": "North Korea", "code": "KP"},
                    {"name": "South Korea", "code": "KR"},
                    {"name": "Kuwait", "code": "KW"},
                    {"name": "Kyrgyzstan", "code": "KG"},
                    {"name": "Laos", "code": "LA"},
                    {"name": "Latvia", "code": "LV"},
                    {"name": "Lebanon", "code": "LB"},
                    {"name": "Lesotho", "code": "LS"},
                    {"name": "Liberia", "code": "LR"},
                    {"name": "Libyan Arab Jamahiriya", "code": "LY"},
                    {"name": "Liechtenstein", "code": "LI"},
                    {"name": "Lithuania", "code": "LT"},
                    {"name": "Luxembourg", "code": "LU"},
                    {"name": "Macao", "code": "MO"},
                    {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
                    {"name": "Madagascar", "code": "MG"},
                    {"name": "Malawi", "code": "MW"},
                    {"name": "Malaysia", "code": "MY"},
                    {"name": "Maldives", "code": "MV"},
                    {"name": "Mali", "code": "ML"},
                    {"name": "Malta", "code": "MT"},
                    {"name": "Marshall Islands", "code": "MH"},
                    {"name": "Martinique", "code": "MQ"},
                    {"name": "Mauritania", "code": "MR"},
                    {"name": "Mauritius", "code": "MU"},
                    {"name": "Mayotte", "code": "YT"},
                    {"name": "Mexico", "code": "MX"},
                    {"name": "Federated States of Micronesia", "code": "FM"},
                    {"name": "Moldova, Republic of", "code": "MD"},
                    {"name": "Monaco", "code": "MC"},
                    {"name": "Mongolia", "code": "MN"},
                    {"name": "Montserrat", "code": "MS"},
                    {"name": "Morocco", "code": "MA"},
                    {"name": "Mozambique", "code": "MZ"},
                    {"name": "Myanmar", "code": "MM"},
                    {"name": "Namibia", "code": "NA"},
                    {"name": "Nauru", "code": "NR"},
                    {"name": "Nepal", "code": "NP"},
                    {"name": "Netherlands", "code": "NL"},
                    {"name": "Netherlands Antilles", "code": "AN"},
                    {"name": "New Caledonia", "code": "NC"},
                    {"name": "New Zealand", "code": "NZ"},
                    {"name": "Nicaragua", "code": "NI"},
                    {"name": "Niger", "code": "NE"},
                    {"name": "Nigeria", "code": "NG"},
                    {"name": "Niue", "code": "NU"},
                    {"name": "Norfolk Island", "code": "NF"},
                    {"name": "Northern Mariana Islands", "code": "MP"},
                    {"name": "Norway", "code": "NO"},
                    {"name": "Oman", "code": "OM"},
                    {"name": "Pakistan", "code": "PK"},
                    {"name": "Palau", "code": "PW"},
                    {"name": "Palestinian Territory, Occupied", "code": "PS"},
                    {"name": "Panama", "code": "PA"},
                    {"name": "Papua New Guinea", "code": "PG"},
                    {"name": "Paraguay", "code": "PY"},
                    {"name": "Peru", "code": "PE"},
                    {"name": "Philippines", "code": "PH"},
                    {"name": "Pitcairn", "code": "PN"},
                    {"name": "Poland", "code": "PL"},
                    {"name": "Portugal", "code": "PT"},
                    {"name": "Puerto Rico", "code": "PR"},
                    {"name": "Qatar", "code": "QA"},
                    {"name": "Reunion", "code": "RE"},
                    {"name": "Romania", "code": "RO"},
                    {"name": "Russian Federation", "code": "RU"},
                    {"name": "RWANDA", "code": "RW"},
                    {"name": "Saint Helena", "code": "SH"},
                    {"name": "Saint Kitts and Nevis", "code": "KN"},
                    {"name": "Saint Lucia", "code": "LC"},
                    {"name": "Saint Pierre and Miquelon", "code": "PM"},
                    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
                    {"name": "Samoa", "code": "WS"},
                    {"name": "San Marino", "code": "SM"},
                    {"name": "Sao Tome and Principe", "code": "ST"},
                    {"name": "Saudi Arabia", "code": "SA"},
                    {"name": "Senegal", "code": "SN"},
                    {"name": "Serbia and Montenegro", "code": "CS"},
                    {"name": "Seychelles", "code": "SC"},
                    {"name": "Sierra Leone", "code": "SL"},
                    {"name": "Singapore", "code": "SG"},
                    {"name": "Slovakia", "code": "SK"},
                    {"name": "Slovenia", "code": "SI"},
                    {"name": "Solomon Islands", "code": "SB"},
                    {"name": "Somalia", "code": "SO"},
                    {"name": "South Africa", "code": "ZA"},
                    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
                    {"name": "Spain", "code": "ES"},
                    {"name": "Sri Lanka", "code": "LK"},
                    {"name": "Sudan", "code": "SD"},
                    {"name": "Suriname", "code": "SR"},
                    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
                    {"name": "Swaziland", "code": "SZ"},
                    {"name": "Sweden", "code": "SE"},
                    {"name": "Switzerland", "code": "CH"},
                    {"name": "Syrian Arab Republic", "code": "SY"},
                    {"name": "Taiwan", "code": "TW"},
                    {"name": "Tajikistan", "code": "TJ"},
                    {"name": "Tanzania", "code": "TZ"},
                    {"name": "Thailand", "code": "TH"},
                    {"name": "Timor-Leste", "code": "TL"},
                    {"name": "Togo", "code": "TG"},
                    {"name": "Tokelau", "code": "TK"},
                    {"name": "Tonga", "code": "TO"},
                    {"name": "Trinidad and Tobago", "code": "TT"},
                    {"name": "Tunisia", "code": "TN"},
                    {"name": "Turkey", "code": "TR"},
                    {"name": "Turkmenistan", "code": "TM"},
                    {"name": "Turks and Caicos Islands", "code": "TC"},
                    {"name": "Tuvalu", "code": "TV"},
                    {"name": "Uganda", "code": "UG"},
                    {"name": "Ukraine", "code": "UA"},
                    {"name": "United Arab Emirates", "code": "AE"},
                    {"name": "United Kingdom", "code": "GB"},
                    {"name": "United States", "code": "US"},
                    {"name": "United States Minor Outlying Islands", "code": "UM"},
                    {"name": "Uruguay", "code": "UY"},
                    {"name": "Uzbekistan", "code": "UZ"},
                    {"name": "Vanuatu", "code": "VU"},
                    {"name": "Venezuela", "code": "VE"},
                    {"name": "Viet Nam", "code": "VN"},
                    {"name": "British Virgin Islands", "code": "VG"},
                    {"name": "USVI", "code": "VI"},
                    {"name": "Wallis and Futuna", "code": "WF"},
                    {"name": "Western Sahara", "code": "EH"},
                    {"name": "Yemen", "code": "YE"},
                    {"name": "Zambia", "code": "ZM"},
                    {"name": "Zimbabwe", "code": "ZW"}
                ],
                bindProps: {
                    defaultCountry: "USA",
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: "Enter a phone number",
                    required: true,
                    enabledCountryCode: true,
                    enabledFlags: true,
                    preferredCountries: ["USA"],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "off",
                    name: "telephone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    dropdownOptions: {
                        disabledDialCode: false
                    },
                    inputOptions: {
                        showDialCode: false
                    }
                },
                location: '',
                searchResults: [],
                hintSelected: false,
            }
        },
        props: {
            triggerCloseModal: ''
        },
        metaInfo () {
            return {
                script: [{
                    src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBvAuWDKz9dAP1Td4ZXSfdcrbeN9cX_glg&region=US&language=en-US&libraries=places',
                    async: true,
                    defer: true,
                    callback:() => this.mapsInit()
                }]
            }
        },
        methods: {
            saveNewContact() {
                if (this.newAddress.contactNumber.dialCode == null || this.newAddress.contactNumber.number == null) {
                    this.phoneNumberValidation = true
                }
                this.$validator.validateAll().then((result) => {
                    if (result && !this.phoneNumberValidation) {
                        if(this.newAddress.addressLine2 == '') {
                            delete this.newAddress.addressLine2;
                        }

                        if(this.newAddress.state == '' || this.newAddress.country != 'United States') {
                            delete this.newAddress.state;
                        }

                        Axios.put(globalStore.data.restApiUrl + '/shipping/address', this.newAddress)
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Address was added',
                                    text: 'New Location Address Added Successfully',
                                    duration: 5000,
                                });
                                this.$emit('triggerCloseModalAdd', true)
                            }).catch(error => {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Address wasn\' added',
                                    text: 'New Location Address Not Processed - Contact Support',
                                    duration: 5000,
                                });
                                console.log(error)
                                this.$emit('triggerCloseModalAdd', true)
                                console.log(error)
                        })
                    }
                }).catch(err => {
                    console.log(err)
                });
            },
            parseNewPhoneNumber(number, isValid, country) {
                if (isValid.isValid) {
                    this.phoneNumberValidation = false;
                    this.newAddress.contactNumber.dialCode = isValid.number.e164.slice(0,(isValid.number.e164.length - isValid.number.significant.length));
                    this.newAddress.contactNumber.number = isValid.number.significant;
                } else {
                    this.phoneNumberValidation = true;
                }
            },
            hideAddAddressModal() {
                this.$emit('triggerCloseModalAdd', true)
            },
            unlockHints() {
                this.hintSelected = false
            },
            getSelectedLocation(location) {
                this.geoServices.geocode({
                    placeId: location.place_id
                }, (result, status) => {
                    this.location = location.description
                    this.hintSelected = true
                    this.parseSelectedOption(result[0])
                })
            },
            parseSelectedOption(data) {
                this.newAddress.addressLine1 = ''
                this.newAddress.addressLine2 = ''
                this.newAddress.city = ''
                this.newAddress.state = ''
                this.newAddress.postalCode = ''
                this.newAddress.country = ''
                let address = data.formatted_address
                let streetParsed = address.substr(0, address.indexOf(','))
                this.newAddress.addressLine1 = streetParsed
                let addressObject = data.address_components
                for (let part of addressObject) {
                    if (part.types[0] == "postal_town") {
                        this.newAddress.city = part.long_name
                    } else if (part.types[0] == "locality" && part.types[1] == "political") {
                        this.newAddress.city = part.long_name
                    } else if (part.types[0] == "administrative_area_level_1" && part.types[1] == "political") {
                        this.newAddress.state = part.short_name
                    } else if (part.types[0] == "country" && part.types[1] == "political") {
                        this.newAddress.country = part.long_name
                    } else if (part.types[0] == "postal_code") {
                        this.newAddress.postalCode = part.long_name
                    }
                }
            },
            getGeocoderRequest(placeId) {
                this.geoServices('GeocoderRequest', {
                    placeId: placeId
                }, this.geocoderResponse)
            },
            geocoderResponse(response, status) {
                console.log(response, status);
            },
            mapsInit() {
                this.service = new window.google.maps.places.AutocompleteService();
                this.geoServices = new window.google.maps.Geocoder();
            },
            displaySuggestions (predictions, status) {
                if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                    this.searchResults = [];
                    return
                }
                this.searchResults = predictions.map(prediction => prediction);
            }
        },
        watch: {
            location (newValue) {
                if (newValue) {
                    this.service.getPlacePredictions({
                        input: this.location
                    }, this.displaySuggestions)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .new-address-modal {
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /*min-height: 100vh;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(44, 44, 44, 0.9);
        z-index: 3030;

        &.wrapper-disable {
            display: none;
        }

        .modal-body {
            display: flex;
            flex-direction: column;
            width: 30vw;
            height: 100vh;
            margin: 10vh auto;
            padding: 1.5vh 1.5vw;

            .modal-inner {
                max-height: 100%;
                border: 1px solid #C9CFD4;
                display: flex;
                flex-direction: column;
                padding: 0 20px 20px 20px;
                justify-content: space-between;
                background-color: #FFFFFF;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                overflow: auto;

                .auto-fill-address {
                    position: relative;
                    margin: 0 0 20px;
                    .auto-fill-input {
                        margin: 0 0 20px;
                    }
                    .auto-fill-hints-list {
                        position: absolute;
                        top: 35px;
                        left: 0;
                        right: 0;
                        border: 1px solid #c9cfd4;
                        border-top: 0;
                        border-bottom-right-radius: 5px;
                        border-bottom-left-radius: 5px;
                        background-color: #fff;
                        z-index: 10;
                        .auto-fill-hint {
                            padding: 4px 10px;
                            border-bottom: 1px solid #c9cfd4;
                            cursor: pointer;
                            &:hover {
                                background-color: #f0f3f5;
                            }
                            &:last-child {
                                border-bottom: 0;
                            }
                        }
                    }
                }

                fieldset {
                    select {
                        &.form-control {
                            display: block;
                            max-width: none;
                        }
                    }
                }

                .header-line {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    h3 {
                        display: block;
                        padding: 20px 0;
                        margin: 0;
                        font: 700 15px/20px "Roboto", "Arial", sans-serif;
                        color: #2F353A;
                    }

                    button {
                        background-color: transparent;
                        border: 0;
                        i {
                            margin: 0 !important;
                        }
                    }
                }
                .city-zipcode {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .half-width {
                        flex-grow: 1;
                        &:first-child {
                            margin-right: 10px;
                        }
                        &:last-child {
                            margin-left: 10px;
                        }
                    }
                }
            }

            .control-bar {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                background-color: #fff;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
                border: 1px solid #d3d8dc;
                border-top: none;
                .btn-primary {
                    margin-left: 10px;
                }
            }

            .validate-warning {
                color: red;
            }
        }
    }

    .dark-theme {
        .modal-body {
            .modal-inner {
                border-color: #171a1e;
                background-color: #3a4149;

                .header-line {
                    h3 {
                        color: #EDEEEF;
                    }
                }
                label,
                .fa-close {
                    color: #EDEEEF;
                }

                select,
                input {
                    background-color: #2f353a;
                    border-color: #171a1e;
                    color: #EDEEEF;
                    &::placeholder {
                        color: #EDEEEF;
                    }
                }
            }
            .control-bar {
                border-color: #171a1e;
                background-color: #3a4149;
            }
        }
    }


</style>
